import { PIMAccordionSummary } from './PIMAccordionSummary';

export default PIMAccordionSummary;
